<div>
  <div class="caught-up-icon">
    <div class="line"></div>
    <span class="icon icon-thumb_up"></span>
    <div class="line"></div>
  </div>
  <div class="caught-up-text">{{ 'cards.allCaughtUp' | translate }}</div>
</div>
